import { render, staticRenderFns } from "./DataListZones.vue?vue&type=template&id=29a9f8c1&scoped=true&"
import script from "./DataListZones.vue?vue&type=script&lang=js&"
export * from "./DataListZones.vue?vue&type=script&lang=js&"
import style0 from "./DataListZones.vue?vue&type=style&index=0&id=29a9f8c1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a9f8c1",
  null
  
)

export default component.exports